<svg
  [ngClass]="[
    'svg-icon',
    'svg-icon-' + icon,
    iconClasses,
    inheritColor ? 'inherit-color' : '',
    applyIconSizeModification ? 'svg-icon-size-small' : '',
    applyIconSizeModification && (iconWidth || iconHeight) ? 'svg-icon-size-scalable' : '',
    applyIconSizeModification && isResponsive ? 'svg-icon-size-responsive' : ''
  ]"
  [style]="iconWidth || iconHeight ? { width: iconWidth, height: iconHeight || iconWidth } : null"
  [attr.aria-label]="title"
  [attr.aria-hidden]="!title"
  focusable="false"
  role="img"
>
  <use [attr.xlink:href]="spriteUrl"></use>
</svg>
